import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function GilbertPage() {
  return <LocationPageTemplate city="Gilbert" cityShort="Gilbert" slug="gilbert" data-id="element-1014" />;
}